// close mega menu if clicked outside while open
const closeMegaMenu = () => {
  const masthead = document?.querySelector("#masthead");
  const searchButton = document?.querySelector(".navbar-one__search-btn");
  if (masthead) {
    document.addEventListener("click", (e) => {

      if (!masthead.contains(e.target)) {
        masthead.classList.remove("mega-menu-open");

        if(document.body.classList.contains("navSearchOpen")) {
          searchButton.classList.remove("close")
          document.body.classList.remove("navSearchOpen")
        }

        const menuItemsWithChildren = masthead.querySelectorAll(
          ".menu-item-has-children"
        );
        menuItemsWithChildren.forEach((item) => {
          item.classList.remove("open");
        });

        const megaMenuOneDropdowns = masthead.querySelectorAll(".mega-menu-one");

        megaMenuOneDropdowns.forEach((dropdown) => {
          dropdown.setAttribute("data-open", "false");
        })
      }
    });
  }
};

if (document.readyState !== "loading") {
  closeMegaMenu();
} else {
  document.addEventListener("DOMContentLoaded", closeMegaMenu);
}
